/**
 * @fileoverview HomePage icons (intro card + authenticated greeting). JSON
 * files in `public/icons/HomePage/`. `greetingBrain` shares its file with the
 * Learn slide placeholder, so it lives in `public/icons/shared/`.
 */
export const HOME_ICONS = {
  chevronRight: '/icons/HomePage/wired-outline-31-chevron-right-hover-scale.json',
  greetingWave: '/icons/HomePage/wired-outline-2319-wave-hello-hand-in-reveal.json',
  greetingBrain: '/icons/shared/wired-outline-426-brain-in-reveal.json',
  greetingBulb: '/icons/HomePage/wired-outline-36-bulb-in-reveal.json',
  /** Currently unused — kept for reference. */
  home: '/icons/HomePage/pbbsmkso.json',
} as const;
